import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App.js';
import {BrowserRouter} from "react-router-dom";
import { Amplify } from 'aws-amplify';
import awsconfig from './aws-exports';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import { store } from './store';
import { loadAuthFromStorage } from './store/slices/authSlice';
import { loadMateFromStorage } from './store/slices/mateSlice';

// Konfigurerer AWS Amplify med indstillinger fra aws-exports
Amplify.configure(awsconfig);

// Hydrér auth fra localStorage før første render — undgår race hvor queries springes over
// eller kører før Redux kender login-state.
store.dispatch(loadAuthFromStorage());
store.dispatch(loadMateFromStorage());

serviceWorkerRegistration.register();

// Renderer React-applikationen i root-elementet
ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById('root')
); 